import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

/**
 * DefaultLayout
 * @param props
 * @returns {*}
 * @constructor
 */
export default function DefaultLayout(props) {
  const { children, navigation } = props;

  const renderNavigation = () => {
    if (navigation) {
      return navigation;
    }
    return null;
  };

  return (
    <div className="DefaultLayout">
      {renderNavigation()}
      <div className="ContentContainer">
        {children}
      </div>
    </div>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
  navigation: PropTypes.node,
};

DefaultLayout.defaultProps = {
  navigation: null,
};
